"use strict";

var _slicedToArray = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _helpers = require("../../../../utils/helpers");

var _BurgerButton = _interopRequireDefault(require("../../BurgerButton"));

var _AccountNav = _interopRequireDefault(require("../../../AccountNav"));

var _AccountNav2 = require("../../../AccountNav/AccountNav");

var _MegaMenu = require("./MegaMenu.style");

var _hooks = require("../../../../utils/hooks");

var _HeaderLogo = _interopRequireDefault(require("../../HeaderLogo"));

var _MenuSlider = _interopRequireDefault(require("../../MenuSlider"));

var MegaMenu = function MegaMenu(_ref) {
  var links = _ref.links,
      homeLink = _ref.homeLink,
      actions = _ref.actions,
      secondaryActions = _ref.secondaryActions,
      account = _ref.account,
      isLargeSlider = _ref.isLargeSlider,
      sliderFooterPrimaryNav = _ref.sliderFooterPrimaryNav,
      sliderFooterSecondaryNav = _ref.sliderFooterSecondaryNav;
  var hasMounted = (0, _hooks.useHasMounted)(); // clean up to make sure scrolling is always enabled when navigating to a new page or unmounting the component

  (0, _react.useEffect)(function () {
    return (0, _helpers.lockWindow)(false);
  }, []);

  var _ref2 = (0, _react.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      isNavOpen = _ref3[0],
      setIsNavOpen = _ref3[1];

  var _ref4 = (0, _emotionTheming.useTheme)(),
      header = _ref4.header,
      colors = _ref4.colors;

  var logoProps = {
    color: colors[header.logo.color],
    height: header.logo.height,
    width: header.logo.width
  };

  var toggleNav = function toggleNav() {
    setIsNavOpen(!isNavOpen);
    (0, _helpers.lockWindow)(!isNavOpen);
  };

  var onlyAccountPrimaryLinks = !!account && !!account.accountPrimaryLinks && !account.avatar && !account.avatarNotifications;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_MegaMenu.MegaMenuWrap, null, /*#__PURE__*/_react.default.createElement(_MegaMenu.LogoWrapper, {
    isNavOpen: isNavOpen
  }, /*#__PURE__*/_react.default.createElement(_HeaderLogo.default, Object.assign({
    homeLink: homeLink
  }, logoProps))), actions.length > 0 && !account && /*#__PURE__*/_react.default.createElement(_MegaMenu.NavWrapper, null, actions && actions.map(function (action) {
    return /*#__PURE__*/_react.default.createElement(_MegaMenu.NavBtn // eslint-disable-next-line react/no-array-index-key
    , Object.assign({
      key: action.label,
      variant: "primary"
    }, action), action.label);
  })), /*#__PURE__*/_react.default.createElement(_MegaMenu.OperationNav, null, account && /*#__PURE__*/_react.default.createElement(_MegaMenu.AccountWrap, {
    account: account,
    onlyAccountPrimaryLinks: onlyAccountPrimaryLinks
  }, /*#__PURE__*/_react.default.createElement(_AccountNav.default, {
    account: account,
    variant: "mega"
  })), /*#__PURE__*/_react.default.createElement(_MegaMenu.BurgerWrap, null, /*#__PURE__*/_react.default.createElement(_BurgerButton.default, {
    toggled: false,
    toggle: setIsNavOpen,
    onClick: toggleNav,
    variation: "mega"
  })))), hasMounted && /*#__PURE__*/_react.default.createElement(_MenuSlider.default, {
    links: links,
    actions: actions,
    isNavOpen: isNavOpen,
    setIsNavOpen: setIsNavOpen,
    footerPrimaryNav: sliderFooterPrimaryNav,
    footerSecondaryNav: sliderFooterSecondaryNav,
    isLargeNav: isLargeSlider,
    toggleNav: toggleNav,
    account: account,
    secondaryActions: secondaryActions
  }));
};

MegaMenu.propTypes = {
  account: _propTypes.default.shape(_AccountNav2.accountPropTypes),
  actions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  isLargeSlider: _propTypes.default.bool,
  secondaryActions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    startIcon: _propTypes.default.string
  })),
  homeLink: _propTypes.default.string,
  links: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    description: _propTypes.default.string,
    navItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string,
      url: _propTypes.default.string
    }))
  })),
  sliderFooterPrimaryNav: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  sliderFooterSecondaryNav: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  }))
};
MegaMenu.defaultProps = {
  account: null,
  actions: [],
  secondaryActions: [],
  isLargeSlider: false,
  homeLink: '/',
  links: [],
  sliderFooterPrimaryNav: [],
  sliderFooterSecondaryNav: []
};
var _default = MegaMenu;
exports.default = _default;